<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'AttributesMain',
  }
</script>

<style lang="scss" scoped>

</style>
